import axios from "axios";
import { endpoints } from "../config/endpoints";
// Function to make POST requests
const API1 = endpoints.api.chat;
const APIr = endpoints.api.retrieveMessages;

// const data = {
//   input: {
//     human_input: input,
//   },
//   config: {
//     configurable: {
//       conversation_id: 122,
//       user_id: document.cookie.split("=")[1],
//       chatBotId,
//     },
//   },
// };

export async function post_ai(path, data, bot_id) {
  let API = API1;

  const result = await fetch(API + path, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    mode: "cors",
    body: JSON.stringify(data),
  });

  const response = await result.json();

  // Log the success message to console only
  if (response.message === "Job submitted successfully") {
    console.log(response.message);
    // Return only the job_id
    return { job_id: response.job_id };
  }

  return response;
}

// Function to retrieve messages
export async function retrieve_messages(
  user_id,
  num_messages,
  bot_id,
  thread_id
) {
  // Validate that all required parameters are provided
  if (!user_id || !num_messages || bot_id === undefined || !thread_id) {
    console.error("Missing required parameters for retrieve_messages");
    console.error(
      `user_id: ${user_id}, num_messages: ${num_messages}, bot_id: ${bot_id}, thread_id: ${thread_id}`
    );
    return [];
  }

  const data = {
    user_id: user_id,
    num_messages: num_messages,
    bot_id: bot_id,
    thread_id: thread_id,
  };

  console.log(`Retrieving messages with data:`, data);
  console.log(`Endpoint URL: ${APIr}`);

  try {
    const result = await fetch(APIr, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      mode: "cors",
      body: JSON.stringify(data),
    });

    if (!result.ok) {
      const errorText = await result.text();
      console.error(
        `Error retrieving messages. Status: ${result.status}, Response: ${errorText}`
      );
      return [];
    }

    const responseData = await result.json();
    console.log(`Retrieved messages:`, responseData);
    return responseData;
  } catch (error) {
    console.error("Error retrieving messages:", error);
    return [];
  }
}

// Function to check the job status
export const check_job_status = async (jobId, chatBotId) => {
  const statusUrl = `${endpoints.api.chat}/status/${jobId}`;
  const response = await axios.get(statusUrl);
  return response.data;
};
